import React from "react";
import InventarioReporte from "./InventarioReporte";
export default function ListaUsuariosTemporales() { return <InventarioReporte kind="usuarios" />; }
